import { PortalAside, StickyElement } from "@/shared/portal";
import { usePalette } from "@/shared/theme";
import { ReactNode } from "react";

export function Grid({
  content,
  header,
  navigation,
  breadcrumbs,
}: {
  header: ReactNode;
  navigation: ReactNode;
  content: ReactNode;
  breadcrumbs: ReactNode;
}) {
  return (
    <div>
      <div className="bg-white fixed top-0 z-10 w-screen">
        <div className="container h-[var(--header-height)]">{header}</div>
      </div>

      <div className="relative mt-[var(--header-height)]">
        <Substrate />
        <div className="container pt-[var(--header-indent)] relative z-[1] pb-[--content-padding-bottom]">
          <div className={"mb-[--breadcrumbs-margin-bottom]"}>
            {breadcrumbs}
          </div>
          <div className="grid xl:grid-cols-[auto_minmax(680px,_1fr)_auto]  gap-2">
            <NavigationWrapper>
              <StickyElement>{navigation}</StickyElement>
            </NavigationWrapper>

            <div className="grow">{content}</div>

            <div>
              <StickyElement>
                <PortalAside />
              </StickyElement>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function NavigationWrapper({ children }: { children: ReactNode }) {
  return <div className={"only-desktop"}>{children}</div>;
}

function Substrate() {
  const palette = usePalette();

  return (
    <div
      className="h-[190px] absolute top-0 left-0 w-screen"
      style={{
        background: `linear-gradient(180deg, ${palette.primary[5]} 0%, ${palette.primary[7]} 84.79%, ${palette.primary[8]} 100%)`,
      }}
    />
  );
}
